const getRestrictedUserEmails = () => {
  const restrictedUserEmailsString =
    process.env.REACT_APP_RESTRICTED_USER_EMAILS

  if (!restrictedUserEmailsString) {
    console.warn(
      'Restricted user emails not found. Please set the environment variable REACT_APP_RESTRICTED_USER_EMAILS.',
    )
  }

  return restrictedUserEmailsString ? restrictedUserEmailsString.split(',') : []
}

export const isUserRestricted = (email: string) => {
  const restrictedUserEmails = getRestrictedUserEmails()
  return restrictedUserEmails.includes(email)
}
